<template>
  <div class="detailPage">
    <div class="banner">
      <img :src="form.goods_thumb_full">
      <!-- <div class="share" @click="showShare = true"></div> -->
    </div>
    <div class="main">
     <div class="left">
        <span class="price">¥{{forms.shopgroup_joinprice}}</span><span class="oldPrice">¥{{form.shop_price}}</span>
     </div>
      <!-- <div class="group">
        <div class="icon"></div>
        <div class="span1">4人成团</div>
        </div> -->
        <div class="right">
          <div class="prompt">
            <div class="img"></div>
            <div class="time"><span>距离结束时间仅剩：</span></div>
          </div>
            <van-count-down :time="time">
              <template v-slot="timeData">
                <span class="currentday">{{ timeData.days }}</span>
                天
                <span class="currentday">{{ timeData.hours }}</span>
                :
                <span class="currentday">{{ timeData.minutes }}</span>
                :
                <span class="currentday">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
        </div>
    </div>
    <div class="course">
        <p>{{forms.shopgroup_desc}}</p>
        <span>{{forms.shopgroup_projectname}}</span><span> |</span>
        <span>{{forms.shopgroup_count}}人已成团</span><br>
    </div>
    <div class="begin">
        <div class="begin-top" v-show="shoing">拼团正在进行中，快来参与吧</div>
        <div class="begin-top" v-show="showing">恭喜你，拼团成功啦</div>
        <div class="begin-bottom">
          <p v-show="display"><span class="span1">{{usergroup_count+'/'+ forms.shopgroup_joinnumber}}</span>， 还差<span>{{forms.shopgroup_joinnumber - usergroup_count}}人</span>即可拼团成功</p>
          <p v-show="showss"><span class="span1">{{usergroup_count +'/'+ forms.shopgroup_joinnumber}}</span>，拼团成功</p>
          <div class="icon">
            <!-- <div class="person" v-for="(item,index) in list" :key="index"></div> -->
          <van-row type="flex" justify="center">
            <van-col span="number" v-for="count in number" :key="count"><div class="person"></div></van-col>
            <van-col span="3"><div class="persons" v-show="reveal"></div></van-col>
          </van-row>
          </div>
          <div class="button" @click="showShare = true" v-show="friend">邀请好友</div>
          <div class="button" v-show="showng" @click="study">进入学习</div>
        </div>
    </div>
    <div class="footer">
      <p><span>订单编号：</span><span>{{order_sn}}</span></p>
      <p><span>下单时间：</span><span>{{order_time}}</span></p>
    </div>
    <!-- 分享弹框 -->
    <van-popup v-model="showShare" :style="{ height: '100%', width: '100%',backgroundColor:'rgba(0,0,0,0.6)' }">
      <van-image :src="shareBgSrc1" width="100%"></van-image>
      <van-image
        @click="showShare = !showShare"
        :src="shareBgSrc2"
        style="margin-left:20%;"
      ></van-image>
    </van-popup>
  </div>
</template>

<script>
import {api_group,api_goods} from '@/common/Request.js';
import wx from "weixin-js-sdk";
import Utils from "../common/weixin";
export default {
  data() {
    return {
      showShare: false,
      shareBgSrc1: require("../assets/share1.png"),
      shareBgSrc2: require("../assets/share2.png"),
      forms:{
        shopgroup_desc:''
      },
      time:'',
      form: {
        goods_thumb: '',
      goods_thumb_full: '',
      shop_price: '',
      },
      order_sn: '',
      order_time: '',
      number: '',
      showss:false,
      shows:true,
      showing:false,
      showng:false,
      shoing:true,
      usergroup_id: '',
      shopgroup_id: '',
      display: true,
      reveal:true,
      friend:true,
      usergroup_count: '',
      // token:'MjI2NywxNTg3NjA3NzU4LDE4ODYyMTAxNDk4',
      token: '',
      goods_id: ''
    }
  },
  mounted() {

  },
  created() {
    let self = this;
    //初始化wx配置
    Utils.initWXConfig(this, function() {
      //callback
      wx.hideAllNonBaseMenuItem();
      wx.showMenuItems({
        menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      });
      //init shareconfig
      let shareConfig = self.initShareConfig();
      Utils.updateWxShareMenu(shareConfig);
    });
this.getList()
  },
  methods: {
    initShareConfig() {
      let config = {
        link: window.location.href,
        title: this.shopgroup_title,
        desc: "这个课程真是优惠，快来看看！",
        imgUrl: this.forms.shopgroup_img
      };
      // console.log('zzz',config);

      return config;
    },
    group() {
      this.$router.push({path:'my_group'})
    },
    // 渲染列表
  getList() {
      if(this.$route.query.shopgroup_id !== undefined) {
        this.shopgroup_id = this.$route.query.shopgroup_id
        // console.log(this.shopgroup_id);

        this.order_sn = this.$route.query.order_sn
        this.order_time = this.$route.query.order_time
        this.usergroup_count = this.$route.query.usergroup_completecount
        // console.log("this.usergroup_count",this.usergroup_count);

        this.number = Number(this.$route.query.usergroup_completecount)
      }
      if(this.$route.query.usergroup_shopgroupid !==undefined) {
        this.usergroup_id = this.$route.query.usergroup_id
        this.shopgroup_id = this.$route.query.usergroup_shopgroupid
        this.order_sn = this.$route.query.usergroup_userordersn
        this.order_time = this.$route.query.usergroup_userordertime
        this.usergroup_count = this.$route.query.usergroup_count
        this.number = Number(this.$route.query.usergroup_count)
      }
      if(this.$route.query.id == 2) {
            // this.shows = false
            this.showing = true
            this.showng =true
            this.shoing = false
            this.display = false
            this.showss = true
            this.reveal = false
            this.friend = false
      }
	  api_group.shopgroup_detail(this.shopgroup_id).then(res=>{
        this.forms =res.data
        // console.log("222",res.data);

        // this.number = Number(res.data.shopgroup_count)
        // if(res.data.shopgroup_count - res.data.shopgroup_joinnumber == 0) {
        //     this.shows = true
        //     this.showing = true
        //     this.showng = true
        //     this.shoing =false
        //     this.friend = false
        // }
        if(this.$route.query.id == 2) {
          this.number = Number(res.data.shopgroup_joinnumber)
        }
        // console.log('res',res.data)
        this.goods_id = res.data.shopgroup_goodsid
        const starttime = (new Date()).valueOf()
        const endtime = +new Date(res.data.shopgroup_endtime)
        const time = endtime - starttime
        this.time = time
        this.setList()
      })
    },
    setList() {
		api_goods.goods_detail(this.goods_id).then(res=>{
        this.form = res.data
        // console.log(res.data)
      })
    },
    // 进入学习
    study() {
      this.$router.push({path:'goods_detail',query:{goodsid:this.goods_id}})
    },
    goDetail() {
      const id = item.usergroup_id
     this.token = this.$cookies.get("user_token")
	 api_group.usergroup_joingroup(id,this.token).then(res=>{
           if(res.code === 0) {
              this.lists = res.data;
              this.$router.push({path:'payment_group',query:{shopgroup_id:id, order_id:this.lists.order_id,order_amount:this.lists.order_amount,order_sn:this.lists.order_sn}})
           }
        // console.log('res',res)
      })
    }
  }
}
</script>

<style scoped>
.detailPage {
  /* position: relative; */
  background-color: #f3f3f3;
  overflow: hidden;
}
.van-share-sheet__options {
      padding: 16px 0 16px 110px;

}
  .banner {
    position: relative;
    width: 100%;
    height: 13.4375rem /* 215/16 */;
    /* background-color: pink; */
  }
  .banner img {
    width: 100%;
    height: 13.4375rem /* 215/16 */;
  }
  .share {
    position: absolute;
    top: 1.25rem /* 20/16 */;
    right: 1.25rem /* 20/16 */;
    width: 1.375rem /* 22/16 */;
    height: 1.375rem /* 22/16 */;
    /* background-color: #000; */
    background: url('/img/fenxiang.png') no-repeat;
    /* background-size: 1.375rem 1.375rem; */
    background-size: 100% 100%;
  }
  .main {
    width: 100%;
    height: 4rem /* 64/16 */;
    background-color: #FE5A59;
  }
  .price {
    font-size: 1.1875rem /* 19/16 */;
    color:#FEDEAF;
    font-weight: 700;
    line-height: 4rem;
    margin-left: 1.25rem /* 20/16 */;
  }
  .oldPrice {
    line-height: 4rem;
    font-size: .75rem /* 12/16 */;
    color: #fff;
    text-decoration: line-through;
    margin-left: .3125rem /* 5/16 */;
  }
  .left {
    float: left;
  }
  .group {
    height: 1.25rem /* 20/16 */;
    width: 5.0625rem /* 65/16 */;
    background-color: #FFD597;
    display: inline-block;
    font-size: .3125rem /* 5/16 */;
    border-radius: 1.46875rem /* 7.5/16 */;
    margin-left: 1rem /* 40/16 */;
    line-height: .9375rem;
    padding-left: .625rem /* 10/16 */;
    margin-top: 1.5rem /* 10/16 */;
  }
  .group .icon {
    display: inline-block;
    height: 1.375rem /* 22/16 */;
    width: 1.375rem /* 22/16 */;
    background: url('/img/pople.png') no-repeat;
    background-size: 100% 100%;
  }
  .group .span1 {
    float: right;
    margin-top: .25rem /* 4/16 */;
    margin-right: .625rem /* 10/16 */;
    color: #FE5A59;
    font-size: .3125rem/* 8/16 */;
  }
  .right .img {
    display: inline-block;
    background: url('/img/naozhong.png') no-repeat;
    height: 1.25rem /* 20/16 */;
    width: 1.25rem /* 20/16 */;
    background-size: 100% 100%;
    /* float: left; */
    margin-top: .3125rem /* 5/16 */;
  }
  .right .img {
    display: inline-block;
    background: url('/img/naozhong.png') no-repeat;
    height: 1.25rem /* 20/16 */;
    width: 1.25rem /* 20/16 */;
    background-size: 100% 100%;
    /* float: left; */
    margin-top: .3125rem /* 5/16 */;
  }
  .right {
    box-sizing: border-box;
    padding-top: .625rem /* 10/16 */;
    float: right;
    background-color: #FF3635;
    width: 9.5625rem /* 153/16 */;
    height: 100%;
    padding-left: .625rem
  }
  .right ::v-deep .currentday {
    display: inline-block;
    width: 1.25rem;
    background-color: #fff;
    height: 1.25rem;
    text-align: center;
    color: #FF3635;
    /* line-height: 1.25rem; */

    font-size: 1rem
  }
  .right .prompt {
    display: flex;
  }
  .right .time {
    float: right;
    margin-right: 0.7rem /* 20/16 */;
  }
  .right span {
    /* vertical-align: middle; */
    color: #fff;
    font-size: .5625rem /* 9/16 */;
  }
  .course {
    height: 3.9375rem /* 95/16 */;
    background-color: #fff;
    padding-top: .9375rem /* 15/16 */;
    padding-left: .9375rem /* 15/16 */;
  }
  .course p {
    font-size: .875rem /* 14/16 */;
    color: #333333;
  }
  .course span {
    color: #A9A9A9;
    font-size: .75rem /* 12/16 */;
  }
  .begin {
    /*width: 23.4375rem /* 375/16 */;
    height: 16rem /* 256/16 */;
    background-color: #fff;
    margin-top: .625rem /* 10/16 */;
  }
  .begin-top {
    height: 2.8125rem /* 45/16 */;
    border-bottom: 1px solid #f3f3f3;
    text-align: center;
    font-size: .8125rem /* 13/16 */;
    line-height: 2.8125rem /* 45/16 */;
  }
  .begin-bottom {
    box-sizing: border-box;
    padding-top: 1.5625rem /* 25/16 */;
    text-align: center;
    font-size: .6875rem /* 11/16 */;
  }
  .begin-bottom span {
    color: #FE5A59;
  }
  .begin-bottom .span1 {
    color: #333333;
  }
  .footer {
    box-sizing: border-box;
    padding-top: .9375rem /* 15/16 */;
    height: 5.1875rem /* 83/16 */;
    /*width: 23.4375rem /* 375/16 */;
    background-color: #fff;
    margin-top: .625rem /* 10/16 */;
  }
  .footer p {
    height: 1.875rem /* 30/16 */;
    font-size: .75rem /* 12/16 */;
    margin-left: 1.25rem /* 20/16 */;
  }
  .icon {
     box-sizing: border-box;
    padding-top: 1.875rem /* 30/16 */;
    height: 6.25rem /* 100/16 */;
    width: 23.4375rem /* 375/16 */;
  }
  .icon .person {
    margin-left: 1.25rem /* 20/16 */;
   width: 2.5rem /* 40/16 */;
    height: 2.5rem /* 24/16 */;
    /* background-color: pink; */
    border-radius: 1.75rem /* 12/16 */;
    background: url('/img/touxiang.png') no-repeat;
    background-size: 100% 100%;
    /* background-color: red; */
    float: left;
  }
  .icon .persons {
    margin-left: 1.25rem /* 20/16 */;
   width: 2.5rem /* 40/16 */;
    height: 2.5rem /* 24/16 */;
    /* background-color: pink; */
    border-radius: 1.75rem /* 12/16 */;
    background: url('/img/tianjia.png') no-repeat;
    background-size: 100% 100%;
    /* background-color: red; */
    float: left;
  }
  .button {
    margin: 0 auto;
    font-size: .75rem /* 12/16 */;
    color: #fff;
    text-align: center;
    line-height: 2.1875rem /* 35/16 */;
    width: 10rem /* 160/16 */;
    height: 2.1875rem /* 35/16 */;
    background-color: #FE5A59;
    border-radius: .1875rem /* 3/16 */;
  }
</style>
